export default {
  checkCircle: 'mdi-check-circle',
  cancel: 'mdi-close-circle',
  radioButtonChecked: 'mdi-radiobox-marked',
  radioButtonUnchecked: 'mdi-radiobox-blank'
};
